export const MAP_SEED = 0;

// Keep the following constants in-sync with gen/src/lib.rs

export const CELL_RESULTS = {
  Open: 0,
  Normal: 1,
  Bomb: 2,
};
export const CHUNK_SIZE = 16;

export const CELL_STATES = {
  Flagged: 1,
  Clicked: 2,
};
